/**
 * This controller organize the bot metadata for the consumer info widget
 * @instance lpBaseInfoController
 */

define(function (require) {
    window.lpTag = window.lpTag || {};
    var lpBaseInfoController =  require('web-agent-assets-js/lpBaseInfoController');
    var lpUtils = require('utils/lpUtils');

    var lpBotMetadataInfoController = function (model) {
        this.model = model;
        this.applicationType = "lpBotMetadataInfoController";
        this.visitorsData = {};
    };

    lpBotMetadataInfoController.prototype = new lpBaseInfoController();

    lpBotMetadataInfoController.prototype.listenForMetadata = function (visitorId, chatId) {
        if(this.visitorsData[visitorId]) {
            if(this.visitorsData[visitorId].chatId === chatId) {
                //already listening
                return;
            }
            this.dismiss(visitorId);
        }
        this.visitorsData[visitorId] = {chatId: chatId};
        if(chatId) {
            this.visitorsData[visitorId].oldMetadataHandler = this._metadataHandler.bind(this, visitorId, true);
            this.visitorsData[visitorId].newMetadataHandler = this._metadataHandler.bind(this, visitorId, false);
            this.model.bind('chats.' + chatId + ".oldChatLine.lines", this.visitorsData[visitorId].oldMetadataHandler, this);
            this.model.bind('chats.' + chatId + ".newChatLine.lines", this.visitorsData[visitorId].newMetadataHandler, this);
        }
    };

    lpBotMetadataInfoController.prototype.dismiss = function (visitorId){
        if(this.visitorsData[visitorId] && this.visitorsData[visitorId].chatId) {
            this.model.unbind('chats.' + this.visitorsData[visitorId].chatId + ".oldChatLine.lines", this.visitorsData[visitorId].oldMetadataHandler, this);
            this.model.unbind('chats.' + this.visitorsData[visitorId].chatId + ".newChatLine.lines", this.visitorsData[visitorId].newMetadataHandler, this);
            delete this.visitorsData[visitorId];
        }
    };

    lpBotMetadataInfoController.prototype._metadataHandler = function (visitorId, isQueryMessages , data) {
        var info = isQueryMessages ? {} : lpUtils.cloneObject(this.model.get("participants.info." + visitorId + ".data.bot.topics") || {});
        _.each(data.newValue, function (value) {
            if(value.metadata && value.metadata.length) {
                _.each(value.metadata, function (metadata) {
                    switch (metadata.type) {
                        case 'BotResponse':
                            if(metadata.businessCases && metadata.businessCases.length) {
                                if (!info.sectionsArray) {
                                    info.sectionsArray = [];
                                    info.sectionsArray.push({topics: []});
                                }
                                if (_.last(info.sectionsArray).reason) {
                                    info.sectionsArray.push({topics: []});
                                }
                                _.each(metadata.businessCases, function (bcase) {
                                    var normalizedTopic = decodeURIComponent(bcase);
                                    if (_.last(_.last(info.sectionsArray).topics) !== normalizedTopic) {
                                        info.sectionsArray[info.sectionsArray.length - 1].topics.push(normalizedTopic);
                                    }
                                });
                            }
                            break;
                        case 'EscalationSummary':
                            info.sectionsArray[info.sectionsArray.length - 1].duration = lpTag.WebAgent.logicController.getFormatDurationTime(metadata.conversationDuration).tooltip;
                            info.sectionsArray[info.sectionsArray.length - 1].reason = decodeURIComponent(metadata.escalationCause || '');
                            break;
                    }
                });
            }
        });
        if(!_.isEmpty(info)) {
            this.model.set("participants.info." + visitorId + ".data.bot.topics", info);
        }
    };

    return lpBotMetadataInfoController;
});
